import React from "react";

import { CameraAccess } from "./CameraAccess";
import { CaptureId } from "./CaptureId";
import { CaptureFace } from "./CaptureFace";
import { useIncode } from "./IncodeContext";

export const Router = () => {
  const { step } = useIncode();

  switch (step) {
    case "capture_id":
      return <CaptureId />;
    case "capture_face":
      return <CaptureFace />;
    case "enable_camera_access":
      return <CameraAccess />;
    default:
      return null;
  }
};
